import React, {CSSProperties} from "react";

import styles from './Button.module.css'
import {cn} from "../../../utils/cn.ts";
import {useScreenDetector} from "../../../hooks/useScreenDetector.ts";
import {Icon} from "../Icon/Icon.tsx";

type BtnType = 'regular' | 'search' | 'text';

interface Props {
    type?: BtnType
    disabled?: boolean
    children?: React.ReactNode
    style?: string| CSSProperties
    id?: string
    onClick?: (value?: any) => void
}

export const Button: React.FC<Props & React.HTMLAttributes<HTMLButtonElement>> = ({
                                                                                      children,
                                                                                      className,
                                                                                      style,
                                                                                      id,
                                                                                      type = 'regular',
                                                                                      onClick,
                                                                                        disabled = false
                                                                                  }) => {
    const {isMobile, isDesktop} = useScreenDetector();

    const isSearch = type === 'search';
    const isRegular = type === 'regular';
    const isText = type === 'text';

    return <>
        {isSearch && isDesktop && (
            <button style={style} className={cn(styles.btn, styles.btnDesktop, className)} onClick={onClick} id={id}>
                <Icon name='search' width={18} height={18} color='#fff'></Icon>
                <div>Поиск</div>
            </button>
        )}

        {isSearch && isMobile && (
            <button className={cn(styles.btn, styles.btnMobile, className)} onClick={onClick} id={id}>
                <Icon name='search' width={18} height={18} color='#fff'></Icon>
            </button>
        )}

        {isRegular && (
            <button style={style} className={cn(styles.btn, className)} onClick={onClick} disabled={Boolean(disabled)} id={id}>
                {children}
            </button>
        )}

        {isText && (
            <button style={style} className={cn(styles.text, className)} onClick={onClick} id={id}>
                {children}
            </button>
        )}
    </>
}